<div class="login-screen" *ngIf="canShowPage">
    <div class="row m-0">
        <div class="col-lg-5 p-0">
            <div class="image-height" [ngClass]="decryptUserTypeId == 3 ? 'firmSignupquestion-height' : 'signupquestion-height'">
                <div class="logo-header">
                    <!-- Feature 210: this page is always standard Senem RFP branding.
                         No agency white-label logo, even when arriving from a referral link. -->
                    <img src="assets/images/logo.svg" class="img-fluid" alt="" srcset="">
                </div>
            </div>
        </div>
        <div class="col-lg-7 p-0">
            <div class="contentLogin">
                <div class="logo-header justify-content-end">
                    <h5 class="m-0">{{'HAVE_ACCOUNT' | translate }} &nbsp;<a href="#" class="fw-medium">{{'SIGN_IN' | translate }}!</a></h5>
                </div>
                <div class="loginbox signupquestion">
                    <h2 class="text-center mb-4">{{'SIGN_UP' | translate }}</h2>
                    <p>{{'SIGN_UP_PARAGRAPH' | translate }}</p>
                    <form class="login-form" [formGroup]="signUpQuestion" (ngSubmit)="form.form.valid" #form="ngForm" autocomplete="off">
                        <div class="mb-3">
                            <mat-label>{{'FIRST_QUESTION' | translate }} <span class="text-danger">*</span></mat-label>
                            <input matInput class="w-100 form-control" [placeholder]="'WRITE_YOUR_QUESTION_PLACEHOLDER' | translate " formControlName="firstQuestion">
                            <mat-error class="text-danger"
                                *ngIf="(form.submitted || signUpQuestion.get('firstQuestion')?.touched) && signUpQuestion.controls['firstQuestion'].errors?.['required']">
                                {{'FIRST_QUESTION_REQUIRED_MSG' | translate }}
                            </mat-error>
                             <mat-error  class="text-danger" *ngIf=" (form.submitted || signUpQuestion.get('firstQuestion')?.touched)&&signUpQuestion.get('firstQuestion')?.hasError('minlength')">
                                {{'FIRST_QUESTION_VALIDATION_MSG_MIN_REQUIRE' | translate }}
                              </mat-error>
                            <mat-error  class="text-danger" *ngIf=" (form.submitted || signUpQuestion.get('firstQuestion')?.touched)&&signUpQuestion.get('firstQuestion')?.hasError('maxlength')">
                                {{'FIRST_QUESTION_VALIDATION_MSG' | translate }}
                              </mat-error>
                              <mat-error class="text-danger" *ngIf=" (form.submitted || signUpQuestion.get('firstQuestion')?.touched)&&signUpQuestion.get('firstQuestion')?.hasError('whitespace')">
                                {{'WHITESPACE_VALIDATION_MSG' | translate }}
                              </mat-error>
                        </div>

                        <div class="mb-3">
                            <mat-label>{{'FIRST_ANSWER' | translate }} <span class="text-danger">*</span></mat-label>
                            <input matInput class="w-100 form-control" [placeholder]="'WRITE_YOUR_ANSWER_PLACEHOLDER' | translate" formControlName="firstQuestionAnswer">
                            <mat-error class="text-danger"
                            *ngIf="(form.submitted || signUpQuestion.get('firstQuestionAnswer')?.touched) && signUpQuestion.controls['firstQuestionAnswer'].errors?.['required']">
                            {{'FIRST_QUESTION_ANSWER_REQUIRED_MSG' | translate }}
                            </mat-error>
                            <mat-error *ngIf="signUpQuestion.get('firstQuestionAnswer')?.hasError('maxlength')">
                                {{'FIRST_QUESTION_ANSWER_VALIDATION_MSG' | translate }}
                            </mat-error>
                        </div>

                        <div class="mb-3">
                            <mat-label>{{'SECOND_QUESTION' | translate }} <span class="text-danger">*</span></mat-label>
                            <input matInput class="w-100 form-control" [placeholder]="'WRITE_YOUR_QUESTION_PLACEHOLDER' | translate " formControlName="secondQuestion">
                            <mat-error class="text-danger"
                            *ngIf="(form.submitted || signUpQuestion.get('secondQuestion')?.touched) && signUpQuestion.controls['secondQuestion'].errors?.['required']">
                            {{'SECOND_QUESTION_REQUIRED_MSG' | translate }}
                            </mat-error>
                             <mat-error  class="text-danger" *ngIf=" (form.submitted || signUpQuestion.get('secondQuestion')?.touched)&&signUpQuestion.get('secondQuestion')?.hasError('minlength')">
                                {{'SECOND_QUESTION_VALIDATION_MSG_MIN_REQUIRE' | translate }}
                              </mat-error>
                            <mat-error *ngIf="signUpQuestion.get('secondQuestion')?.hasError('maxlength')">
                                {{'SECOND_QUESTION_VALIDATION_MSG' | translate }}
                            </mat-error>
                        </div>

                        <div class="mb-3">
                            <mat-label>{{'SECOND_ANSWER' | translate }} <span class="text-danger">*</span></mat-label>
                            <input matInput class="w-100 form-control" [placeholder]="'WRITE_YOUR_ANSWER_PLACEHOLDER' | translate" formControlName="secondQuestionAnswer">
                            <mat-error class="text-danger"
                            *ngIf="(form.submitted || signUpQuestion.get('secondQuestionAnswer')?.touched) && signUpQuestion.controls['secondQuestionAnswer'].errors?.['required']">
                            {{'SECOND_QUESTION_ANSWER_REQUIRED_MSG' | translate }}
                        </mat-error>
                        <mat-error *ngIf="signUpQuestion.get('secondQuestionAnswer')?.hasError('maxlength')">
                            {{'SECOND_QUESTION_ANSWER_VALIDATION_MSG' | translate }}
                        </mat-error>

                        </div>
                        <div class="mb-3">
                            <mat-label>{{'THIRD_QUESTION' | translate }} <span class="text-danger">*</span></mat-label>
                            <input matInput class="w-100 form-control" [placeholder]="'WRITE_YOUR_QUESTION_PLACEHOLDER' | translate " formControlName="thirdQuestion">
                            <mat-error class="text-danger"
                                *ngIf="(form.submitted || signUpQuestion.get('thirdQuestion')?.touched) && signUpQuestion.controls['thirdQuestion'].errors?.['required']">
                                {{'THIRD_QUESTION_REQUIRED_MSG' | translate }}
                            </mat-error>
                             <mat-error  class="text-danger" *ngIf=" (form.submitted || signUpQuestion.get('thirdQuestion')?.touched)&&signUpQuestion.get('thirdQuestion')?.hasError('minlength')">
                                {{'THIRD_QUESTION_VALIDATION_MSG_MIN_REQUIRE' | translate }}
                              </mat-error>
                            <mat-error *ngIf="signUpQuestion.get('thirdQuestion')?.hasError('maxlength')">
                                {{'THIRD_QUESTION_VALIDATION_MSG' | translate }}
                            </mat-error>
                        </div>

                        <div class="mb-3">
                            <mat-label>{{'THIRD_ANSWER' | translate }} <span class="text-danger">*</span></mat-label>
                            <input matInput class="w-100 form-control" [placeholder]="'WRITE_YOUR_ANSWER_PLACEHOLDER' | translate" formControlName="thirdQuestionAnswer" autocomplete="off"  autocomplete="off" autocorrect="off">
                            <mat-error class="text-danger"
                            *ngIf="(form.submitted || signUpQuestion.get('thirdQuestionAnswer')?.touched) && signUpQuestion.controls['thirdQuestionAnswer'].errors?.['required']">
                            {{'THIRD_QUESTION_ANSWER_REQUIRED_MSG' | translate }}
                            </mat-error>

                            <mat-error *ngIf="signUpQuestion.get('thirdQuestionAnswer')?.hasError('maxlength')">
                                {{'THIRD_QUESTION_ANSWER_VALIDATION_MSG' | translate }}
                            </mat-error>
                        </div>

                        <div class="mb-3">
                            <mat-label>{{'PASSWORD' | translate }} <span class="text-danger">*</span></mat-label>
                            <div class="position-relative">
                                    <input matInput class="w-100 form-control" [placeholder]="'PASSWORD' | translate" formControlName="password" type="{{passwordinputType}}" autocomplete="off">
                                    <div  (click)="changeInputType(passwordinputType,'password')">
                                        <mat-icon matSuffix *ngIf="passwordinputType == 'password'" aria-hidden="false"
                                            aria-label="Visibility Off" fontIcon="visibility_off"></mat-icon>
                                        <mat-icon *ngIf="passwordinputType == 'text'" aria-hidden="false" aria-label="Visibility On"
                                            fontIcon="visibility_on"></mat-icon>
                                    </div>
                                    <!-- <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon=" visibility_off"></mat-icon> -->
                                    <mat-error class="text-danger"
                                        *ngIf="(form.submitted || signUpQuestion.get('password')?.touched) && signUpQuestion.controls['password'].errors?.['required']">
                                        {{'PASSWORD_REQUIRED_MSG' | translate }}
                                    </mat-error>
                                    <mat-error class="text-danger"
                                    *ngIf="(form.submitted || signUpQuestion.get('password')?.touched) &&
                                           signUpQuestion.get('password')?.hasError('pattern')">
                                            {{'PASSWORD_VALIDATION_MSG' | translate }}
                                  </mat-error>
                            </div>
                        </div>

                        <div class="mb-3">
                            <mat-label>{{'CONFIRM_PASSWORD' | translate }} <span class="text-danger">*</span></mat-label>
                            <div class="position-relative">
                                <input matInput class="w-100 form-control" [placeholder]="'CONFIRM_PASSWORD' | translate" formControlName="confirmPassword" type="{{confirmPasswordinputTypes}}">
                                <div (click)="changeInputType(confirmPasswordinputTypes,'confirmPassword')">
                                    <mat-icon *ngIf="confirmPasswordinputTypes == 'password'" aria-hidden="false"
                                        aria-label="Visibility Off" fontIcon="visibility_off"></mat-icon>
                                    <mat-icon *ngIf="confirmPasswordinputTypes == 'text'" aria-hidden="false" aria-label="Visibility On"
                                        fontIcon="visibility_on"></mat-icon>
                                </div>
                                <!-- <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon=" visibility"></mat-icon> -->
                                <mat-error class="text-danger"
                                *ngIf="(form.submitted || signUpQuestion.get('confirmPassword')?.touched) && signUpQuestion.controls['confirmPassword'].errors?.['required']">
                                {{'CONFIRM_PASSWORD_REQUIRED_MSG' | translate }}
                                </mat-error>
                                <!-- <mat-error class="text-danger"
                                *ngIf="(form.submitted || signUpQuestion.get('confirmPassword')?.touched) &&
                                       signUpQuestion.get('confirmPassword')?.hasError('pattern')">
                                        {{'PASSWORD_VALIDATION_MSG' | translate }}
                              </mat-error> -->
                              <mat-error *ngIf="signUpQuestion.get('confirmPassword')?.hasError('mustMatch')">
                                {{ 'PASSWORD_MUST_MATCH_TOASTER' | translate }}
                              </mat-error>

                            </div>
                        </div>

                        <!-- <div class="mb-3">
                            <mat-label>{{'HAVE_REFERRAL_CODE' | translate }} </mat-label>
                            <input matInput class="w-100 form-control" [placeholder]="'REFERRAL_CODE' | translate " formControlName="referralCode">
                        </div> -->

                        <div class="mb-3">
                            <mat-label>{{'HOW_YOU_HEARD_ABOUT_US' | translate }} <span class="text-danger">*</span></mat-label>
                            <mat-form-field class="w-100">
                              <mat-select formControlName="heardAboutUS" >
                                <mat-option *ngFor="let item of hearedAboutUs" [value]="item.value">{{ item.viewValue }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-error class="text-danger"
                              *ngIf="(form.submitted || signUpQuestion.get('heardAboutUS')?.touched) && signUpQuestion.controls['heardAboutUS'].errors?.['required']">
                              {{'HEARD_ABOUT_US_REQUIRED_MSG' | translate }}
                              </mat-error>
                          </div>
                          
                      <p class="text-left">{{'SIGN_UP_QUESTION_CHECKBOX' | translate }}</p>
                        <div class="d-flex align-items-center justify-content-between w-100 gap-3 mb-3">
                            <div>
                                <mat-checkbox 
                                    class="example-margin" 
                                    color="primary" 
                                    name="termsCheckbox" 
                                    (change)="onCheckboxChange($event)">
                                </mat-checkbox>
                            </div>
                            <div>
                                {{'CHECKBOX_TERMS' | translate }} 
                                <a class="link" (click)="redirectToTermsAndConditionsPage()">{{'TERMS_OF_USE' | translate }}</a> {{'AND' | translate }} <a class="link" (click)="openDialog('PrivacyPolicy')">{{'PRIVACY_POLICY' | translate }}</a>
                            </div>
                        </div>
                        <div *ngIf="!isChecked && showError" class="text-danger">
                            <mat-error class="text-danger">
                                {{'TERMS_REQUIRED' | translate }}.
                            </mat-error>
                          </div>
                        <button mat-flat-button color="primary" class="my-3 w-100" (click)="onSignUp()">{{'SIGN_UP' | translate }}</button>
                    </form>
                </div>
            </div>
          
        </div>

      
    </div>
</div>
<div class="login-screen expired-message" *ngIf="!canShowPage">
    <div class="message-box">
      <h2>
        <i class="fa fa-exclamation-circle"></i>
        {{ 'This signup link has expired. Please request a new one.' }}
      </h2>
  
      <button class="btn btn-primary mt-3" (click)="router.navigate(['/login'])">
        {{'BACK_TO_LOGIN' | translate }}
      </button>
    </div>
</div>
